// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/assist.scss
// module id = pyIg
// module chunks = 101